export default __webpack_public_path__ + "static/media/GalanoGrotesque-Light.bc372599.woff";